function PaymentMethod () {
  function filter (value) {
    switch (value) {
      case 'undefined':
        return 'Não informado'

      case 'cred':
        return 'Crédito À Vista'

      case 'cred_parc':
        return 'Crédito Parcelado'

      case 'debt':
        return 'Débito'

        case 'dinh':
          return 'Dinheiro'

        case 'pix':
          return 'Pix'

        case 'bol':
          return 'Boleto'

        case 'tot':
          return 'Total'

      default:
        return 'Não informado'
    }
  }

  return {
    filter
  }
}

export default PaymentMethod
